import React, { FC, useState } from 'react';
import DownIcon from '../icons/angle-down-solid.svg';
import RightIcon from '../icons/angle-right-solid.svg';
import styled from 'styled-components';
import { Row, RowProps, StyledRowProps } from './table';
import { TextButton } from '../buttons/textButton';

const StyledRight = styled(RightIcon)`
    width: 1.2rem;
    cursor: pointer;
    color: #455a64;
`;

const StyledDown = styled(DownIcon)`
    width: 1.2rem;
    cursor: pointer;
    color: #455a64;
`;

const TextButtonStyled = styled(TextButton)`
    > span {
        text-align: center;
    }
    display: grid;
    width: max-content;
    cursor: pointer;
`;

const ComponentAndExpandButtonContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    gap: 20px;
    margin-right: 15px;
    margin-left: auto;
`;

const RowFixedColor = styled(Row)<{ expanded?: boolean }>`
    > span {
        background-color: ${(p) => (p.expanded ? ' #f6f8f9 !important' : 'auto')};
        border-bottom: solid 1px #dbe2e6;
    }
`;

interface ExpandButtonProps {
    onExpand: () => void;
}

const ExpandButton: FC<ExpandButtonProps> = (props) => {
    const [expand, setExpand] = useState(false);

    const handleExpand = () => {
        setExpand(!expand);
        props.onExpand();
    };
    return (
        <>
            {!expand && (
                <StyledRight
                    onClick={() => {
                        handleExpand();
                    }}
                />
            )}
            {expand && (
                <StyledDown
                    onClick={() => {
                        handleExpand();
                    }}
                />
            )}
        </>
    );
};

interface ExpandButtonCustomProps {
    onExpand: () => void;
    textOnClosed: string;
    textOnOpen: string;
}

const ExpandButtonCustom: FC<ExpandButtonCustomProps> = (props) => {
    const [expand, setExpand] = useState(false);

    const handleExpand = () => {
        setExpand(!expand);
        props.onExpand();
    };

    return <TextButtonStyled onClick={() => handleExpand()}>{expand ? props.textOnOpen : props.textOnClosed} </TextButtonStyled>;
};

interface ExpandableRowProps {
    content: React.ReactNode;
    useTextButton?: boolean;
    textOnClosed?: string;
    textOnOpen?: string;
    extraComponent?: React.ReactNode;
    isExpandable?: boolean;
    defaultExpanded?: boolean;
    onExpand?: (isExpanded: boolean) => void;
}

const ExpandableRowContainer = styled.div`
    grid-column: 1 / -1;
    box-shadow: 0 1px 0 0 ${(props) => props.theme.app.primary_light};
`;

export const ExpandableRow: FC<RowProps & StyledRowProps & ExpandableRowProps> = (props) => {
    const [expand, setExpand] = useState(props.defaultExpanded ?? false);
    const handleExpand = () => {
        setExpand(!expand);
        if (props.onExpand) {
            props.onExpand(expand);
        }
    };
    function getButton() {
        if (props.isExpandable === false) return <ComponentAndExpandButtonContainer></ComponentAndExpandButtonContainer>;
        else if (props.useTextButton && props.textOnClosed && props.textOnOpen) {
            if (props.extraComponent) {
                return (
                    <ComponentAndExpandButtonContainer>
                        {props.extraComponent}
                        <ExpandButtonCustom onExpand={handleExpand} textOnClosed={props.textOnClosed} textOnOpen={props.textOnOpen} />
                    </ComponentAndExpandButtonContainer>
                );
            } else return <ExpandButtonCustom onExpand={handleExpand} textOnClosed={props.textOnClosed} textOnOpen={props.textOnOpen} />;
        } else return <ExpandButton onExpand={handleExpand}></ExpandButton>;
    }

    const cells = [...props.cells, getButton()];
    return (
        <>
            <RowFixedColor expanded={expand} {...props} cells={cells} />
            {expand && <ExpandableRowContainer>{props.content}</ExpandableRowContainer>}
        </>
    );
};
